<template>
  <div>
    <button @click="toggle()" v-bind:class="buttonClass">
      {{ buttonLabel }}
    </button>
    <div class="columns is-centered"></div>
    <div id="modal-js-example" class="modal" v-bind:class="{'is-active': isActive}">
      <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box">
            <!-- Your content -->
            <slot></slot>
          </div>
        </div>
      <button class="modal-close is-large" aria-label="close" @click="toggle()"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    buttonLabel: String,
    buttonClass: String
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    }
  },
  data () {
    return {
      isActive: false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue